// Dados iniciais para simulação (em um ambiente real, estes dados viriam de uma API)

// Lista de pacientes iniciais
export const pacientesIniciais = [
  {
    id: 1,
    nome: 'Ana Silva',
    email: 'ana.silva@email.com',
    telefone: '(11) 98765-4321',
    dataNascimento: '15/05/1990',
    genero: 'Feminino',
    estadoCivil: 'Casada',
    profissao: 'Engenheira',
    criadoEm: '10/01/2023',
    ultimaConsulta: '25/06/2023',
    proximaConsulta: '25/07/2023',
    status: 'Ativo',
    psicologoId: 1,
    historico: 'Paciente apresenta quadro de ansiedade generalizada e dificuldades em lidar com pressões no ambiente de trabalho.'
  },
  {
    id: 2,
    nome: 'João Santos',
    email: 'joao.santos@email.com',
    telefone: '(11) 98765-1234',
    dataNascimento: '22/09/1985',
    genero: 'Masculino',
    estadoCivil: 'Solteiro',
    profissao: 'Administrador',
    criadoEm: '15/02/2023',
    ultimaConsulta: '18/06/2023',
    proximaConsulta: '18/07/2023',
    status: 'Ativo',
    psicologoId: 1,
    historico: 'Paciente busca acompanhamento para questões relacionadas à gestão do estresse e dificuldades de relacionamento interpessoal.'
  },
  {
    id: 3,
    nome: 'Mariana Costa',
    email: 'mariana.costa@email.com',
    telefone: '(11) 97654-3210',
    dataNascimento: '10/12/1995',
    genero: 'Feminino',
    estadoCivil: 'Solteira',
    profissao: 'Designer',
    criadoEm: '05/03/2023',
    ultimaConsulta: '12/06/2023',
    proximaConsulta: '12/07/2023',
    status: 'Ativo',
    psicologoId: 2,
    historico: 'Paciente relata episódios de ansiedade social e dificuldades em expressar opiniões em ambientes profissionais.'
  },
  {
    id: 4,
    nome: 'Luiz Oliveira',
    email: 'luiz.oliveira@email.com',
    telefone: '(11) 99876-5432',
    dataNascimento: '05/03/1988',
    genero: 'Masculino',
    estadoCivil: 'Divorciado',
    profissao: 'Professor',
    criadoEm: '20/03/2023',
    ultimaConsulta: '05/06/2023',
    proximaConsulta: '05/07/2023',
    status: 'Ativo',
    psicologoId: 2,
    historico: 'Paciente procurou ajuda para lidar com processo de separação e reorganização da vida pessoal. Apresenta sintomas leves de depressão.'
  },
  {
    id: 5,
    nome: 'Carla Mendes',
    email: 'carla.mendes@email.com',
    telefone: '(11) 99765-4321',
    dataNascimento: '18/07/1992',
    genero: 'Feminino',
    estadoCivil: 'Casada',
    profissao: 'Médica',
    criadoEm: '15/04/2023',
    ultimaConsulta: '02/06/2023',
    proximaConsulta: '02/07/2023',
    status: 'Ativo',
    psicologoId: 1,
    historico: 'Paciente apresenta dificuldades relacionadas ao equilíbrio entre vida profissional e pessoal, com sinais de esgotamento profissional.'
  }
];

// Lista de consultas iniciais
export const consultasIniciais = [
  {
    id: 1,
    pacienteId: 1,
    data: '25/06/2023',
    horario: '14:00',
    duracao: 50,
    tipo: 'Terapia Individual',
    plataforma: 'Presencial',
    status: 'Realizada',
    observacoes: 'Paciente relatou melhora na gestão de sintomas de ansiedade após implementação de técnicas de respiração e mindfulness.',
    psicologoId: 1,
    acompanhamentos: [
      {
        id: 1,
        data: '25/06/2023',
        conteudo: 'Paciente demonstrou evolução no controle da ansiedade. Foram discutidas estratégias adicionais para situações de estresse no trabalho.'
      }
    ]
  },
  {
    id: 2,
    pacienteId: 2,
    data: '18/06/2023',
    horario: '15:30',
    duracao: 50,
    tipo: 'Terapia Individual',
    plataforma: 'Online',
    status: 'Realizada',
    observacoes: 'Paciente discutiu dificuldades em ambientes sociais no trabalho e estratégias para lidar com figuras de autoridade.',
    psicologoId: 1,
    acompanhamentos: [
      {
        id: 1,
        data: '18/06/2023',
        conteudo: 'Trabalhamos questões de assertividade. Paciente demonstra progresso ao implementar comunicação mais clara com colegas de trabalho.'
      }
    ]
  },
  {
    id: 3,
    pacienteId: 3,
    data: '12/06/2023',
    horario: '10:00',
    duracao: 50,
    tipo: 'Terapia Individual',
    plataforma: 'Presencial',
    status: 'Realizada',
    observacoes: 'Paciente relatou episódio de ansiedade em apresentação profissional. Foram discutidas técnicas de exposição gradual e reestruturação cognitiva.',
    psicologoId: 2,
    acompanhamentos: [
      {
        id: 1,
        data: '12/06/2023',
        conteudo: 'A paciente está progredindo na identificação de pensamentos automáticos negativos e sua substituição por pensamentos mais realistas e construtivos.'
      }
    ]
  },
  {
    id: 4,
    pacienteId: 4,
    data: '05/06/2023',
    horario: '09:00',
    duracao: 50,
    tipo: 'Terapia Individual',
    plataforma: 'Online',
    status: 'Realizada',
    observacoes: 'Paciente relatou melhora no humor e maior aceitação do processo de separação. Buscando retomar atividades sociais e hobbies.',
    psicologoId: 2,
    acompanhamentos: [
      {
        id: 1,
        data: '05/06/2023',
        conteudo: 'O paciente demonstra avanços significativos na elaboração do luto pela separação. Está desenvolvendo nova rotina e ampliando rede de apoio social.'
      }
    ]
  },
  {
    id: 5,
    pacienteId: 5,
    data: '02/06/2023',
    horario: '17:00',
    duracao: 50,
    tipo: 'Terapia Individual',
    plataforma: 'Presencial',
    status: 'Realizada',
    observacoes: 'Discutimos estratégias para gestão do tempo e estabelecimento de limites no trabalho. Paciente reconhece sinais de burnout e necessidade de autocuidado.',
    psicologoId: 1,
    acompanhamentos: [
      {
        id: 1,
        data: '02/06/2023',
        conteudo: 'A paciente começa a implementar pequenas mudanças em sua rotina para incorporar momentos de descanso e atividades prazerosas. Relatou redução na tensão constante.'
      }
    ]
  },
  {
    id: 6,
    pacienteId: 1,
    data: '25/07/2023',
    horario: '14:00',
    duracao: 50,
    tipo: 'Terapia Individual',
    plataforma: 'Presencial',
    status: 'Agendada',
    observacoes: 'Continuação do trabalho com técnicas cognitivo-comportamentais para manejo da ansiedade.',
    psicologoId: 1
  },
  {
    id: 7,
    pacienteId: 2,
    data: '18/07/2023',
    horario: '15:30',
    duracao: 50,
    tipo: 'Terapia Individual',
    plataforma: 'Online',
    status: 'Agendada',
    observacoes: 'Verificar progresso nas estratégias de comunicação assertiva no ambiente de trabalho.',
    psicologoId: 1
  },
  {
    id: 8,
    pacienteId: 3,
    data: '12/07/2023',
    horario: '10:00',
    duracao: 50,
    tipo: 'Terapia Individual',
    plataforma: 'Presencial',
    status: 'Agendada',
    observacoes: 'Continuar trabalho com exposição gradual a situações que provocam ansiedade social.',
    psicologoId: 2
  }
];

// Dados de profissionais da psicologia
export const psicologosIniciais = [
  {
    id: 1,
    nome: 'Dra. Rafaela Mendes Luz',
    email: 'admin@exemplo.com',
    crp: '06/123456',
    especialidade: 'Psicologia Clínica',
    abordagem: 'Cognitivo-Comportamental',
    telefone: '(11) 98765-4321',
    horarioAtendimento: 'Segunda a Sexta, 8h às 18h',
    valorConsulta: 'R$ 200,00'
  },
  {
    id: 2,
    nome: 'Dr. João Silva',
    email: 'joao.silva@exemplo.com',
    crp: '06/654321',
    especialidade: 'Psicologia Clínica e Organizacional',
    abordagem: 'Integrativa',
    telefone: '(11) 98712-3456',
    horarioAtendimento: 'Segunda a Sexta, 12h às 20h',
    valorConsulta: 'R$ 180,00'
  }
];

// Configurações gerais do sistema
export const configuracoesGeraisIniciais = {
  nomeClinica: 'Consultório Online',
  endereco: 'Av. Paulista, 1000, São Paulo - SP',
  telefone: '(11) 3456-7890',
  email: 'contato@consultorioonline.com',
  site: 'www.consultorioonline.com',
  logo: '/logo.png',
  cores: {
    primaria: '#4a8a84',
    secundaria: '#3a7a74',
    terciaria: '#f5f5f5'
  }
}; 